module.exports = __webpack_public_path__ + "img/VERS3.bebc2fac.png";